import jquery from 'jquery';
import React from 'react';
import { Table, Modal, Button, message } from 'antd';
import API_URL from '../../common/url';
import $ from '../../common/AjaxRequest';
import ExportUtil from '../../common/ExportUtil';
import AddPmFte from './AddPmFte';
import Sider from './PlanSider';
import PlanFteAllocation from './PlanFteAllocation';

const initState = {
    sortParams: {},
    searchParams: {
        userId: '',
        leaderId: ''
    },
    data: [],
    loading: false,
    pagination: {
        pageSize: 10,
        current: 1,
    },
    dataList: [],
}

class PmFte extends React.Component {
    state = initState;

    componentDidMount() {
        this.loadData();
        this.getProjectRegion();
        this.queryInvestigationStageByInvId();
    }

    loadData = (params = {}) => {
        const { role } = this.props;
        this.setState({ loading: true });
        const { searchParams, pagination } = this.state;
        const options = {
            url: `${API_URL.plan.queryAllPmPlanFte}`,
            data: {
                offset: pagination.current,
                ...params,
                ...searchParams,
                limit: pagination.pageSize,
                roleCode: role,
            },
            dataType: 'json',
            doneResult: data => {
                const pagination = { ...this.state.pagination };
                pagination.total = data.totalCount;
                this.setState({
                    loading: false,
                    dataList: data.datas,
                    pagination,
                });

                if ((searchParams.offset && searchParams.offset) > 1 || pagination.current > 1) {
                    const dataList = data.datas || [];
                    if (data.datas.length == 0) {
                        this.reload({}, '', true);
                    }
                }
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    getProjectRegion = () => {
        this.setState({ loading: true });
        const options = {
            url: `${API_URL.plan.queryInvestigationStartEnd}`,
            data: {},
            dataType: 'json',
            doneResult: (data => {
                if (data.error) {
                    Modal.error({ title: data.error });
                    return;
                }
                this.setState({
                    loading: false,
                    planBeginTime: data.startTime,
                    planEndTime: data.endTime,
                });
            }),
        };
        $.sendRequest(options);
    }

    queryInvestigationStageByInvId = () => {
        const { invId: investigationId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    invStageList: data,
                });
            },
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    getColumns = () => {
        const { dataList = [] } = this.state;
        const list = dataList[0] ? dataList[0].fteList : [];
        const fixed = list.length == 0 ? false : "left";
        const width = list.length == 0 ? "auto" : 80;
        const { role } = this.props;
        const { curRole, curEmployeeCode } = sessionStorage;
        const columnNames = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            fixed,
            width,
        }, {
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            fixed,
            width,
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            fixed,
            width,
        }, {
            title: '每月计划合计',
            dataIndex: 'monthTotal',
            key: 'monthTotal',
            fixed,
            width: 90,
        },];
        list && list.map((d, i) => {
            columnNames.push({
                title: d.year + "." + d.month,
                dataIndex: `fteValue${i}`,
                key: `fteValue${i}`,
            });
        })
        if (curRole == "PM" || curRole == "PA") {
            columnNames.push({
                title: '操作',
                width: 80,
                fixed: "right",
                render: (text, record) => {
                    const { isModify, employeeCode, assignmentId } = record;
                    return (
                        <span>
                            {
                                curRole == "PA" ?
                                    (
                                        role === 'PA' ?
                                            (
                                                (curEmployeeCode == employeeCode) && isModify == "1" ?
                                                    <a
                                                        onClick={() => this.canEditByInvStatus(() => this.AddReport.show(assignmentId, "edit", record))}
                                                    >调整</a>
                                                    :
                                                    <a disabled>调整</a>
                                            )
                                            :
                                            <a disabled>调整</a>
                                    )
                                    :
                                    (
                                        isModify == "1" ?
                                            <a
                                                onClick={() => this.canEditByInvStatus(() => this.AddReport.show(assignmentId, "edit", record))}
                                            >调整</a>
                                            :
                                            <a disabled>调整</a>
                                    )
                            }
                        </span>
                    );
                },
            });
        }
        return columnNames;
    }

    getDataSource = () => {
        const records = [];
        const { dataList } = this.state;
        dataList.map((dataItem, i) => {
            const ftelist = {};
            dataItem.fteList.map((d, j) => {
                ftelist[`fteValue${j}`] = d.fte;
            });
            records.push({
                key: dataItem.assignmentId,
                ...dataItem,
                index: i + 1,
                ...ftelist,
            });
        });
        return records;
    }

    handleTableChange = (pagination, filters, sorter) => {
        let sortType,
            direction,
            sort = sort = sorter.field;
        const pager = { ...this.state.pagination };
        if (pager.current == pagination.current) {
            pager.current = 1;
            //排序则页码为1
        } else {
            pager.current = pagination.current;
            //获取当前页
        }
        if (!jquery.isEmptyObject(sorter) && sorter.column) {
            sortType = sorter.column.sortType;
        }
        if (sorter.order === 'descend') {
            direction = 'DESC';
        } else {
            direction = 'ASC';
        }
        this.setState({
            pagination: pager,//设置新的分页信息
            sortParams: {//设置排序信息
                direction,
                sort,
                sortType
            }
        });

        this.loadData({
            limit: pager.pageSize,
            offset: pager.current,
            direction,
            sort,
            sortType,
            ...this.state.searchParams,
            ...filters,
        });
    }

    reload = (params = {}, type, pre) => {
        const newParams = {};
        if (type == "search") {
            newParams.searchParams = params;
            newParams.pagination = { ...this.state.pagination, current: 1 };
        }
        this.setState({
            ...newParams
        }, function () {
            const { pagination, searchParams, sortParams } = this.state;
            this.loadData({
                offset: (!pre && pagination.current > 1) ? pagination.current : pagination.current - 1,
                ...sortParams,
                ...searchParams,
            });
        })
    }

    addReport = () => {
        this.AddReport.show('', "add");
    }

    export = () => {
        const { role } = this.props;
        const { pagination } = this.state;
        ExportUtil.export({ roleCode: role }, pagination, API_URL.plan.exportAllPmPlanFte);
    }

    render() {
        const { role } = this.props;
        const { curRole } = sessionStorage;
        const { loading, pagination, dataList = [], planBeginTime, planEndTime } = this.state;
        return (
            <div className="content">
                <Sider selectKey="degree" />
                <div className="main">
                    <div className="breadcrumb-bar tac">
                        <h2 className="title">{`${role}-FTE计划`}</h2>
                    </div>
                    <div className="filter-bar bar2">
                        <div className="btn" style={{ float: 'right' }}>
                            <Button type="primary" onClick={this.export}>导出</Button>
                            {
                                (curRole == "PM" || (role === 'PA' && curRole == "PA")) &&
                                <Button type="primary" disabled={loading} onClick={() => this.canEditByInvStatus(this.addReport)}>添加</Button>
                            }
                        </div>
                        <div style={{ position: 'absolute', right: 7 }}>
                            <a onClick={() => this.PlanFteAllocationRef.show()}>计划FTE自动分配规则</a> 
                        </div>
                    </div> 
                    <Table
                        columns={this.getColumns()}
                        dataSource={this.getDataSource()}
                        rowKey={record => record.index + record.employeeCode}
                        loading={loading}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                        scroll={{ x: dataList[0] && dataList[0].fteList && dataList[0].fteList.length * 90 + 460 }}
                    />
                    <AddPmFte
                        ref={el => this.AddReport = el}
                        reload={this.reload}
                        planBeginTime={planBeginTime}
                        planEndTime={planEndTime}
                        role={role}
                    />
                    <PlanFteAllocation
                        ref={el => this.PlanFteAllocationRef = el}
                        reload={this.reload}
                        role={role}
                    />
                </div>
            </div>
        );
    }
}

export default PmFte;


// WEBPACK FOOTER //
// ./src/components/plan/PmFte.js